const BUNDLE_PROTECTIONPLAN_ON_CHANGE = 'BUNDLE_PROTECTIONPLAN_ON_CHANGE';

export default BUNDLE_PROTECTIONPLAN_ON_CHANGE;
